module.exports = __webpack_public_path__ + "img/footer_email.658ca918.svg";